import script from "./invoicePage.vue?vue&type=script&setup=true&lang=js"
export * from "./invoicePage.vue?vue&type=script&setup=true&lang=js"

import "./invoicePage.vue?vue&type=style&index=0&id=7d0aa40c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d0aa40c"]])

export default __exports__